import Swiper from "swiper";
import { FreeMode, Thumbs } from "swiper/modules";

const initSinglePage = () => {
  const thumbsEl = document.querySelector(".single-product__images-thumbs");
  const topEl = document.querySelector(".single-product__images-top");
  if (!thumbsEl || !topEl) return;

  const galleryThumbs = new Swiper(thumbsEl, {
    spaceBetween: 8,
    slidesPerView: 4,
    modules: [FreeMode, Thumbs],
    freeMode: true,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    breakpoints: {
      768: { slidesPerView: 5, spaceBetween: 10 },
      1100: { slidesPerView: 6, spaceBetween: 12 },
    },
  });

  const galleryTop = new Swiper(topEl, {
    spaceBetween: 10,
    modules: [FreeMode, Thumbs],
    thumbs: { swiper: galleryThumbs },
  });
};

initSinglePage();
export default initSinglePage;

const showCounterForButton = (buttonEl) => {
  if (!buttonEl) return;
  buttonEl.classList.add("is-hidden");
  const counter = buttonEl.nextElementSibling;
  if (counter && counter.matches("[data-counter]")) {
    // сбрасываем значение к 1 при каждом первом показе
    const valueEl = counter.querySelector("[data-value]");
    if (valueEl) valueEl.textContent = "1";
    counter.classList.remove("is-hidden");
  }
};

const hideCounterAndShowButton = (counterEl) => {
  const buttonEl = counterEl?.previousElementSibling;
  if (buttonEl && buttonEl.classList.contains("button-border-gradient")) {
    buttonEl.classList.remove("is-hidden");
  }
  counterEl.classList.add("is-hidden");
};

const initAddToCartCounter = () => {
  // Click on "Add to cart" buttons (single product and cards)
  document.addEventListener("click", (e) => {
    const addBtn = e.target.closest(".button-border-gradient.button-border-gradient--full");
    if (addBtn) {
      e.preventDefault();
      showCounterForButton(addBtn);
      return;
    }

    // Increment
    const incBtn = e.target.closest("[data-increment]");
    if (incBtn) {
      const counter = incBtn.closest("[data-counter]");
      const valueEl = counter?.querySelector("[data-value]");
      if (!valueEl) return;
      const current = parseInt(valueEl.textContent || "0", 10) || 0;
      // valueEl.textContent = String(current + 1);
      return;
    }

    // Decrement
    const decBtn = e.target.closest("[data-decrement]");
    if (decBtn) {
      const counter = decBtn.closest("[data-counter]");
      const valueEl = counter?.querySelector("[data-value]");
      if (!valueEl) return;
      const current = parseInt(valueEl.textContent || "0", 10) || 0;
      // const next = Math.max(0, current - 1);
      if (next === 0) {
        hideCounterAndShowButton(counter);
      } else {
        valueEl.textContent = String(next);
      }
      return;
    }
  });
};

initAddToCartCounter();
